'<template>
   <div class="list_right" v-loading="loading">
      <div class="right_member_director">
         <div class="title_box" v-if="data != null">
            <h5> <template v-if="data.companyType == 1">会员单位</template>
               <template v-if="data.companyType == 2">理事信息</template>
            </h5>
            <!--  <el-button class="r_btn" type="primary" size="small">变更信息</el-button>-->
         </div>
         <div class="director_formbox">
            <el-form :inline="true" :model="form" class="demo-form-inline">
               <div class="director_top">
                  <div class="imgbox">
                     <img src="../../../assets/images/member/user_img.jpg" alt="">
                  </div>
                  <div class="r_content">
                     <p>姓名：<span>{{form.userName}}</span></p>
                     <p>男 {{form.nation}} {{form.politicalLandscape}}</p>
                     <p>生日：<span>{{form.birthday}} </span></p>
                     <p>身份证号码：<span>{{form.idCard}} </span></p>
                  </div>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="工作单位">
                           <el-input v-model="form.workUnit" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="6">
                        <el-form-item label="职务">
                           <el-input v-model="form.post" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="6">
                        <el-form-item label="职称">
                           <el-input v-model="form.professional" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="单位地址">
                           <el-input v-model="form.workAddress" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="单位性质">
                           <el-input v-model="form.unitProperty" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="法定代表人">
                           <el-input v-model="form.legalRepresentative" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="注册资金">
                           <el-input v-model="form.registeredCapital" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="电子邮箱">
                           <el-input v-model="form.email" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="邮编">
                           <el-input v-model="form.postcode" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="12">
                        <el-form-item label="手机号码">
                           <el-input v-model="form.tel" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                     <el-col :span="12">
                        <el-form-item label="办公电话">
                           <el-input v-model="form.officePhone" placeholder="无" :disabled="disabled"></el-input>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
               <div class="director_row">
                  <el-row :gutter="20">
                     <el-col :span="24">
                        <el-form-item label="本人简历">
                           <div class="jianli" v-html="form.resume"></div>
                        </el-form-item>
                     </el-col>
                  </el-row>
               </div>
            </el-form>
         </div>
      </div>
   </div>
</template>


<script>
   import {
      formatDates,
      getDistanceSpecifiedTime
   } from '@/assets/js/date.js'; // 时间倒计时
   import {
      getCookie,
      delCookie,
      setCookie
   } from '@/assets/js/util'; // cookie操作
   export default {
      name: 'user_director_page',
      components: {},
      data() {
         return {
            loading:false,
            data: null,
            form: {
               name: '',
               region: '',
               date1: '',
               date2: '',
               delivery: false,
               type: [],
               resource: '',
               desc: ''
            },
            disabled: true, //禁止修改

         };
      },
      filters: {

      },
      mounted() {
         this.data = JSON.parse(localStorage.getItem('userInfo'));
         this.getInfo();
      },
      methods: {
         getInfo() {
            var _this = this;
            _this.loading = true;
            _this.$api.contactsInfo({
               token: getCookie('sd_token'),
            }).then(res => {
               _this.loading = false;
               if (res.code == 200) {
                  _this.form = res.data;
               } else {
                  _this.$message.error(res.msg);
               }
            }).catch(function(error) {
               _this.loading = false;
               _this.$message.error(error.msg);
            });
         },
      }
   }
</script>
<style lang="less" scoped>

</style>
